export default {
  fetchCityList (state, payload) {
    state.cityList = payload;
  },
  setSaveListPath (state, payload) {
    state.saveListPath = payload;
  },
  setDemotionSwitch(state, payload) {
    state.demotionSwitch = payload;
  },
  setCurrentCityByIp(state, payload) {
    state.currentCityByIp = payload;
  },
  setXyzStatus(state, payload){
    state.isShowCredit = payload;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js